import {
  MouseSensor as LibMouseSensor,
  TouchSensor as LibTouchSensor,
} from '@dnd-kit/core';
import { MouseEvent, TouchEvent } from 'react';

const hasNoDndAncestor = (el: HTMLElement | null): boolean => {
  if (!el) {
    return false;
  }
  if (el.dataset && el.dataset.noDnd) {
    return true;
  }
  return hasNoDndAncestor(el.parentElement);
};

// Block DnD event propagation if element have "data-no-dnd" attribute
const handler = ({ nativeEvent: event }: MouseEvent | TouchEvent) =>
  !hasNoDndAncestor(event.target as HTMLElement);

export class MouseSensor extends LibMouseSensor {
  static activators = [
    { eventName: 'onMouseDown', handler },
  ] as (typeof LibMouseSensor)['activators'];
}

export class TouchSensor extends LibTouchSensor {
  static activators = [
    { eventName: 'onTouchStart', handler },
  ] as (typeof LibTouchSensor)['activators'];
}
